import React, { useState } from 'react'

const Review = ({ CoursesDetails }) => {
    const getFaqs = (title) => {
        const map = {
            'Technology & Future Trends': [
                { q: 'Is this course technical or non‑technical?', a: 'It is designed for non‑technical and mixed audiences, with optional deeper dives explained in plain language.' },
                { q: 'What topics are covered?', a: 'Artificial intelligence, machine learning, blockchain, Internet of Things, cloud/edge computing, quantum and responsible adoption.' },
                { q: 'How can I use this at work?', a: 'Use the frameworks to evaluate opportunities and risks, brief technical teams, and build simple adoption roadmaps.' },
                { q: 'Do I get updates as tech evolves?', a: 'Yes, you receive lifetime access including future content updates.' }
            ],
            'Health & Wellbeing': [
                { q: 'Is this suitable for beginners?', a: 'Yes. No medical background is required. We focus on evidence‑based wellbeing practices anyone can apply.' },
                { q: 'Will I learn mental wellbeing tools?', a: 'Yes. We cover stress management, sleep, movement and signposting to professional help.' },
                { q: 'Can HR use this for workplace programs?', a: 'Absolutely. Guidance and templates help you design simple workplace wellbeing initiatives.' }
            ],
            'Education & Career Growth': [
                { q: 'Will this help with interviews?', a: 'Yes. You will craft impact‑focused stories, improve your CV/LinkedIn and practise interview answers.' },
                { q: 'Is there a portfolio element?', a: 'We show you how to assemble a skills portfolio and evidence your achievements.' },
                { q: 'Good for career‑changers?', a: 'Yes. The course includes pathway planning for transitions into growth roles.' }
            ],
            'Leadership & Personal Development': [
                { q: 'Do I need to manage a team already?', a: 'No. The content suits aspiring leaders and new managers as well as experienced leads.' },
                { q: 'What practical tools are included?', a: '1:1 templates, feedback frameworks, goal setting, meeting rhythms and change checklists.' },
                { q: 'Is there a focus on soft skills?', a: 'Yes—communication, coaching, conflict resolution and influence.' }
            ],
            'Environment & Sustainability': [
                { q: 'Will I learn how to measure impact?', a: 'Yes. We cover simple footprint, waste and water metrics you can start using immediately.' },
                { q: 'Is this relevant to small organisations?', a: 'Very. The course emphasises practical, low‑cost actions and community engagement.' }
            ],
            'Finance & Economy': [
                { q: 'Do I need accounting knowledge?', a: 'No. We start from budgeting and cash‑flow basics and build up to statements and risk.' },
                { q: 'Is personal finance included?', a: 'Yes—saving, interest, inflation, diversification and simple investment concepts.' }
            ],
            'Future of Work & HR': [
                { q: 'Does this cover hybrid work policies?', a: 'Yes. We provide templates for flexible work, wellbeing, and fair performance management.' },
                { q: 'Is data privacy discussed?', a: 'We cover ethical people analytics, transparency and compliance considerations.' }
            ],
            'Youth & Future Skills': [
                { q: 'What age range is this for?', a: 'Ideal for teens and early‑career learners (14+), with guidance for mentors and parents.' },
                { q: 'Do I need devices/software?', a: 'Only basic access to a computer or smartphone with internet for suggested activities.' }
            ],
            'Media & Digital Arts': [
                { q: 'Will I use professional tools?', a: 'We demonstrate industry tools/workflows and suggest free alternatives where possible.' },
                { q: 'Is there portfolio guidance?', a: 'Yes. You learn to plan projects and present work professionally online.' }
            ],
            'Construction & Skilled Trades': [
                { q: 'Is safety covered?', a: 'Health & safety, PPE, method statements and working to spec are core parts of the course.' },
                { q: 'Good for apprentices?', a: 'Yes. Clear step‑by‑step practice and site communication tips are included.' }
            ],
            'Transport & Logistics': [
                { q: 'Will I learn routing and scheduling?', a: 'Yes—capacity planning, routing basics and on‑time performance metrics.' },
                { q: 'Does it cover compliance?', a: 'We cover safety, record‑keeping and regulatory awareness.' }
            ],
            'Hospitality & Tourism': [
                { q: 'Is this customer‑service focused?', a: 'Yes. Guest journey design, complaints handling and ethical upselling are included.' },
                { q: 'Does it include team leadership?', a: 'Basics for shift leadership and coordination are provided.' }
            ],
            'Beauty & Wellness': [
                { q: 'Do I need experience?', a: 'No. Hygiene, client care and service basics are explained from first principles.' },
                { q: 'Is business setup covered?', a: 'We discuss service menus, pricing and client retention fundamentals.' }
            ],
            'Real Estate & Property Management': [
                { q: 'Does this include tenancy law?', a: 'We give a practical overview and signpost local regulations—always follow your jurisdiction’s rules.' },
                { q: 'Is maintenance planning included?', a: 'Yes—preventive schedules, vendors and communication with tenants/owners.' }
            ],
            'Arts, Media & Creativity': [
                { q: 'How do I find clients/audience?', a: 'You will learn outreach, pitching and social presence essentials.' },
                { q: 'Do I need expensive gear?', a: 'No. Start lean and upgrade as your projects grow.' }
            ],
            'Food & Culinary Skills': [
                { q: 'Is food safety included?', a: 'Yes—core hygiene practices, cross‑contamination avoidance and safe temperatures.' },
                { q: 'Will I learn menu costing?', a: 'Basics of costing, portioning and simple menu design are included.' }
            ],
            'Family & Parenting Support': [
                { q: 'Is this suitable for new parents?', a: 'Yes. Communication strategies, routines and supportive resources are covered.' },
                { q: 'Does it address special needs?', a: 'We provide inclusive guidance and signposting to specialist services.' }
            ],
            'Sports & Fitness Training': [
                { q: 'Do I need gym access?', a: 'No. We offer at‑home variations and explain progressive overload safely.' },
                { q: 'Is injury prevention covered?', a: 'Yes—warm‑ups, mobility and recovery practices are included.' }
            ],
            'Technology & Digital Skills': [
                { q: 'Will I learn office tools?', a: 'Yes—productivity, collaboration, file management and basic automation.' },
                { q: 'Is cybersecurity included?', a: 'Safe passwords, phishing awareness and privacy basics are covered.' }
            ],
            'Business & Entrepreneurship': [
                { q: 'Is there help validating ideas?', a: 'Yes—problem interviews, simple experiments and lean business modelling.' },
                { q: 'Will I learn about finance?', a: 'We cover pricing, cash‑flow basics and tracking traction with simple metrics.' }
            ]
        };

        return map[title] || [
            { q: 'What will I learn?', a: 'A clear, structured pathway from fundamentals to practical skills you can apply.' },
            { q: 'How long is the course?', a: 'Self‑paced with lifetime access so you can learn on your schedule.' }
        ];
    };

    const faqs = getFaqs(CoursesDetails?.title);
    const [openIndex, setOpenIndex] = useState(-1);

    const toggle = (idx) => setOpenIndex(openIndex === idx ? -1 : idx);

    return (
        <div className="wpo-course-content">
            <div className="wpo-course-text-top">
                <h2>FAQs</h2>
                <div className="course-curriculam">
                    <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                        {faqs.map((f, i) => {
                            const isOpen = openIndex === i;
                            return (
                                <li key={i} style={{ marginBottom: '14px' }}>
                                    <div
                                        style={{
                                            background: '#f6f7fb',
                                            border: '1px solid #eef0f4',
                                            borderRadius: '10px',
                                            overflow: 'hidden'
                                        }}
                                    >
                                        <button
                                            onClick={() => toggle(i)}
                                            aria-expanded={isOpen}
                                            style={{
                                                width: '100%',
                                                textAlign: 'left',
                                                background: 'transparent',
                                                border: 'none',
                                                padding: '18px 20px',
                                                fontWeight: 600,
                                                display: 'block',
                                                cursor: 'pointer'
                                            }}
                                        >
                                            <span>{f.q}</span>
                                        </button>
                                        {isOpen && (
                                            <div
                                                style={{
                                                    padding: '0 20px 18px 20px',
                                                    borderTop: '1px solid #e6e8ee',
                                                    background: 'transparent'
                                                }}
                                            >
                                                <p style={{ margin: 0 }}>{f.a}</p>
                    </div>
                                        )}
                                    </div>
                                </li>
                            );
                        })}
                    </ul>
                </div>
            </div>
        </div>
    )
}

export default Review;